import { individualApi, permissionsApi, userApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} rootGetters
   */
  async authorizeAndInitApp({ commit, dispatch, rootGetters }) {
    commit('setError', null);
    commit('setLoading', true);
    await dispatch('auth/authenticate', null, { root: true });
    if (rootGetters['auth/isAuthenticated']) {
      await dispatch('fetchAll');
    }
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   */
  async initApp({ commit, dispatch }) {
    commit('setError', null);
    commit('setLoading', true);
    await dispatch('fetchAll');
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} dispatch
   */
  async fetchAll({ dispatch }) {
    const requests = [
      dispatch('fetchAccount'),
      dispatch('fetchPermissions'),
      dispatch('fetchUser'),
    ];
    await Promise.all(requests);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchAccount({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestMyAccount(token);
      commit('setAccount', response.data);
    }
    catch (error) {
      if (error.response?.status === 404) {
        commit('setAccount', null);
      }
      else {
        commit('setError', error);
      }
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchPermissions({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await permissionsApi.requestPermissionList(token);
      commit('setPermissions', response.data.permissions);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchUser({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await userApi.requestDetail(token);
      commit('setUser', response.data);
    }
    catch (error) {
      if (error.response?.status === 404) {
        commit('setUser', null);
      }
      else {
        commit('setError', error);
      }
    }
  },
};
